<h1 mat-dialog-title>
  {{data.title}}
</h1>

<div mat-dialog-content>
  <p>{{data.message}}</p>
</div>

<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onCancel()" color="info">{{data.cancelText}}</button>
  <button mat-stroked-button (click)="onConfirm()" color="warn">{{data.confirmText}}</button>
</div>
